/**
 * Hier kommt Code für das Mitarbeiter Postfach hin.
 */

import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import { forceUpdateMA } from './ma_daten.js';
import stammdatenService from '../services/stammdatenService.js';

import systemNachrichtService from '../services/systemNachrichtService.js';
import { debounce, downloadLink, erstelleMitarbeiterListe, erstelleOptionGroup, fuelleSelectOptionen, setMenuActive } from '../util.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import basedataService from '../services/basedataService.js';

const debounceUpdateEntwurf = debounce(async () => {
    await updateEntwurf();
}, 1000);

const debounceUpdateDateiName = debounce(async (args) => {
    await editDateiName(args[0]);
});

// Global Event Listeners
window.myHandlers = window.myHandlers || {};
window.myHandlers.generiereArbeitsvertrag = generiereArbeitsvertrag;
window.myHandlers.updateEntwurf = updateEntwurf;
window.myHandlers.debounceUpdateEntwurf = debounceUpdateEntwurf;
window.myHandlers.togglePostfachViewer = togglePostfachViewer;
window.myHandlers.uploadDatei = uploadDatei;
window.myHandlers.erstellePDF = erstellePDF;
window.myHandlers.confirmPDFErstellung = confirmPDFErstellung;
window.myHandlers.debounceUpdateDateiName = debounceUpdateDateiName;
window.myHandlers.sortDokumenteName = sortDokumenteName;
window.myHandlers.sortDokumenteDatum = sortDokumenteDatum;
window.myHandlers.sendNachricht = sendNachricht;
window.myHandlers.revokeNachricht = revokeNachricht;
window.myHandlers.openNachrichten = openNachrichten;


/**
 * initialisiert die Postfach Seite des aktuellen Mitarbeiters
 */
async function ladeMitarbeiterPostfach() {
    // Wir können das Postfach nur öffnen falls ein MA ausgewählt wurde
    if (!_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
        resetPostfachViewer();
        document.getElementById('postfach-filename-edit').value = '';
        await fuelleVorlagenSelect();
        holeVerzeichnisliste();
    } else {
        systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter ausgewählt!', 0);
    }

    // Wir brauchen einen Event Listener, der alle Context Menüs zum Löschen von Dokumenten anbietet
    document.body.querySelector('.schriftverkehr-container').addEventListener('click', (event) => {
        if (event.target.classList.contains('context-delete')) return;
        [...document.body.querySelectorAll('.context-delete')].forEach((menu) => menu.remove());
    });
}

/**
 * Lädt die PDF aus dem Backend und rendert diese
 * @param {string} pdfUrl
 */
async function ladePDF(pdfUrl) {
    try {
        console.log(pdfUrl);
        togglePostfachViewer(3);
        const pdfEmbed = document.getElementById('pdf-embed');
        pdfEmbed.src = pdfUrl;
        if (!pdfEmbed.src || pdfEmbed.src === '') {
            document.getElementById('pdf-embed-msg').style.display = 'block';
        } else {
            document.getElementById('pdf-embed-msg').style.display = 'none';
        }
    } catch (error) {
        console.log(error);
    }
}

function ladeImage(imgUrl) {
    togglePostfachViewer(2);
    document.getElementById('postfach-img').src = imgUrl;
}

async function ladeMarkdown(dokumentID) {
    togglePostfachViewer(1);
    try {
        const response = await fetch(`/neolohn/api/dokument/md/${dokumentID}`);
        if (response.ok) {
            const markdownDatei = await response.json();
            window.myServices.editorService.setMarkdown(markdownDatei.Inhalt);
            window.myServices.editorService.setCurrentFile(markdownDatei);
        }
    } catch (error) {
        console.log(error);
		systemNachrichtService.zeigeKleineNachricht('Laden von Markdown fehlgeschlagen!', -1);
    }
}

/**
 * Lädt die Vorlagen Dokumente vom Server und zeigt sie in dem Select an.
 */
async function fuelleVorlagenSelect() {
	try {
        const select = document.querySelector('#postfach-vorlagen-select');
        select.innerHTML = '';
        if (window.myVars.HideMod || window.myVars.HideMod2) {
            return;
        }
		const response = await fetch('/neolohn/api/vorlage');
		if (!response.ok) {
            const result = await response.text();
            systemNachrichtService.zeigeKleineNachricht(result, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        let listeEigeneVorlagen = await response.json();
        listeEigeneVorlagen = listeEigeneVorlagen.filter((vl) => !vl.InPapierkorb); // Keine im Papierkorb liegenden Vorlagen anzeigen
        // Option Gruppe Eigene Vorlagen
        if (listeEigeneVorlagen.length > 0) {
            listeEigeneVorlagen.sort((a, b) => a.Name.localeCompare(b.Name));
            select.appendChild(erstelleOptionGroup('eigene Vorlagen', listeEigeneVorlagen, '_id', 'Name'));
        }
        const listeStandardVorlagen = await basedataService.holeVorlagenBasedataProvider();
        // Option Gruppe Mustervorlagen
        if (listeStandardVorlagen.length > 0) {
            listeStandardVorlagen.sort((a, b) => a.Name.localeCompare(b.Name));
            select.appendChild(erstelleOptionGroup('Mustervorlagen', listeStandardVorlagen, '_id', 'Name'));
        }
	} catch (error) {
		console.log(error);
		systemNachrichtService.zeigeKleineNachricht('Laden von Vorlagen fehlgeschlagen!', -1);
	}
}

/**
 * Sendet eine PUT Request an den Server, um den Dateinamen zu ändern
 * @param {HTMLElement} thisElement Input Filename
 */
async function editDateiName(thisElement) {
    const aktuelleDatei = document.querySelector('.dokument-item-active');
    if (thisElement.value === '') {
        return;
    }
    if (!aktuelleDatei) {
        systemNachrichtService.zeigeKleineNachricht('Keine Datei ausgewählt!', 0);
        return;
    }
    try {
        const dokumentID = aktuelleDatei.id;
        const newName = thisElement.value;
        const body = {
            DokumentID: dokumentID,
            NeuerName: newName
        };
        const response = await fetch('/neolohn/api/dokument/name', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        if (response.ok) {
            const neuesDokument = await response.json();
            aktuelleDatei.remove();
            const neuesDokumentHTML = erstelleDokumentHTML(neuesDokument);
            document.getElementById('dokumente-liste').insertAdjacentElement('afterbegin', neuesDokumentHTML);
            setMenuActive(neuesDokumentHTML, 'dokument-item-active');
            // Falls wir beim Entwurf Editor den Namen ändern, muss dieser auch seine Current File mit dem neuen Namen updaten
            if (window.myServices.editorService.getCurrentFile()._id === neuesDokument._id) {
                window.myServices.editorService.setFileName(neuesDokument.Name);
            }
            systemNachrichtService.zeigeKleineNachricht('Speichern Erfolgreich!', 1);
        }
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Fehler beim Umbennenen der Datei!', -1);
    }
}

/**
 * Erstellt den Arbeitsvertrag bzw. ein Dokument aus einer Vorlage des Mitarbeiters.
 */
async function generiereArbeitsvertrag() {
    await forceUpdateMA();
    const select = document.querySelector('#postfach-vorlagen-select');
    const vorlageID = select.value;
    const isMustervorlage = select.selectedOptions[0].parentElement.label === 'Mustervorlagen';
    const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
    if (select.value === '' || !vorlageID || !mitarbeiterID) {
        systemNachrichtService.zeigeKleineNachricht('Vorlagenauswahl fehlerhaft!', 0);
        return;
    }

    try {
        const verzeichnisID = stammdatenService.unternehmensobjekt.Verzeichnisse.find((vz) => vz.VerzeichnisName === 'Entwürfe')?._id;
        const body = {
            VorlageID: vorlageID,
            MitarbeiterID: mitarbeiterID,
            VerzeichnisID: verzeichnisID,
            IsMustervorlage: isMustervorlage
        };
        const response = await fetch('/neolohn/api/arbeitsvertrag', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
        if (!response.ok) {
            const result = await response.text();
            systemNachrichtService.zeigeKleineNachricht(result, 0);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const result = await response.json();
        // Zeige den Entwurf im Editor in der Oberfläche an
        window.myServices.editorService.setCurrentFile(result);
        window.myServices.editorService.setMarkdown(result.Inhalt);
        document.getElementById('postfach-filename-edit').value = result.Name;
        const entwurfVerzeichnis = stammdatenService.unternehmensobjekt.Verzeichnisse.find((vz) => vz.VerzeichnisName === 'Entwürfe')._id;
        await holeDocListe(entwurfVerzeichnis);
        const element = document.getElementById(result._id);
        setMenuActive(element, 'dokument-item-active');
        togglePostfachViewer(1);
        systemNachrichtService.zeigeKleineNachricht('Entwurfserstellung erfolgerich!', 1);
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Fehler bei der Erstellung des Arbeitsvertrags!', -1);
    }
}

/**
 * Erstellt ein PDF aus dem aktuellen Entwurf im Editor
 */
async function erstellePDF() {
    if (_.isEmpty(window.myServices.editorService.getCurrentFile())) {
        systemNachrichtService.zeigeKleineNachricht('Kein Entwurf ausgewählt!');
        return;
    }
    const entwurfID = window.myServices.editorService.getCurrentFile()._id;
    const verzeichnisSelect = document.getElementById('pdf-erstellen-verzeichnis-select');
    fuelleSelectOptionen(verzeichnisSelect, stammdatenService.unternehmensobjekt.Verzeichnisse.filter((vz) => vz.VerzeichnisName !== 'Papierkorb'), '_id', 'VerzeichnisName');
    const result = await SystemDialogService.instance.displayAsync('pdf-erstellen-dialog');
	if (!result.success) {
		// User aktion abgebrochen
		return;
	}
    try {
        const response = await fetch('/neolohn/api/erstelle-pdf', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                DokumentID: entwurfID,
                VerzeichnisID: result.data.VerzeichnisID
            })
        });
        if (response.ok) {
            systemNachrichtService.zeigeKleineNachricht('PDF Erfolgreich erstellt!', 1);
            await holeDocListe(window.myServices.editorService.getCurrentFile().VerzeichnisID);
        }
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('PDF Erstellen gescheitert!', -1);
    }
}

async function confirmPDFErstellung() {
    SystemDialogService.instance.confirm({
		VerzeichnisID: document.getElementById('pdf-erstellen-verzeichnis-select').value
	});
}

/**
 * Updated ein Vertragsentwurf
 */
 async function updateEntwurf() {
	try {
		const mdContent = window.myServices.editorService.getMarkdown();
        const oldObject = window.myServices.editorService.getCurrentFile();
		// Bei leeren Content brauchen wir nicht speichern...
		if (mdContent === '' || _.isEmpty(window.myServices.editorService.getCurrentFile())) {
			return;
		}
        oldObject.Inhalt = mdContent;
        const response = await fetch('/neolohn/api/vertragsentwurf', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            body: JSON.stringify(oldObject),
        });
        if (!response.ok) {
            if (response.status === 413) {
                systemNachrichtService.zeigeKleineNachricht('Entwurfsdatei zu groß, bitte nur kleine Bilder (weniger als 100KB) einfügen!', -1);
                return;
            }
            systemNachrichtService.zeigeKleineNachricht('Speichern fehlgeschlagen!', -1);
            return;
        }
        const result = await response.json();
        window.myServices.editorService.setCurrentFile(result);
        systemNachrichtService.zeigeKleineNachricht('Speichern erfolgreich!', 1);
	} catch (error) {
		console.log(error);
		systemNachrichtService.zeigeKleineNachricht('Speichern fehlgeschlagen!', -1);
	}
}

/**
 * Ladet die Dokumente innerhalb eines Verzeichnisses (oder alle) für einen Mitarbeiter
 * @param {string} verzeichnisID ObjectId
 */
async function holeDocListe(verzeichnisID = '') {
    try {
        let query = `?MitarbeiterID=${stammdatenService.aktuellerMitarbeiter._id}`;
        if (verzeichnisID !== '') {
            query += `&VerzeichnisID=${verzeichnisID}`;
        }
        const response = await fetch(`/neolohn/api/dokument/liste${query}`);
        if (response.ok) {
            const result = await response.json();
			const liste = document.querySelector('#dokumente-liste');
            let currentFileActive = document.querySelector('.dokument-liste-item.postfach-item.dokument-item-active')?.id;
			liste.innerHTML = '';
            const papierkorbVZ = stammdatenService.unternehmensobjekt.Verzeichnisse.find((vz) => vz.VerzeichnisName === 'Papierkorb');
            const isPapierkorb = _.isEqual(papierkorbVZ._id, verzeichnisID);
            const neueUploads = stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueUploads || [];
            // Dateien rendern
            result.forEach((item) => {
                // Datei Metadata in das Frontend rendern...
                const newItem = erstelleDokumentHTML(item, isPapierkorb);
                // Add notification badge if document is in NeueUploads array
                if (neueUploads.some((uploadID) => _.isEqual(uploadID, item._id))) {
                    const badge = createNotificationBadge(1, 'Neue Datei');
                    newItem.style.position = 'relative';
                    newItem.appendChild(badge);
                }
				liste.appendChild(newItem);
			});
            if (verzeichnisID !== '') {
                const verzeichnisHTML = document.getElementById(verzeichnisID).children[0];
                setMenuActive(verzeichnisHTML, 'verzeichnis-item-active');
            }
            const lastActiveElement = [...liste.children].find((item) => item.id == currentFileActive);
            if (lastActiveElement) {
                lastActiveElement.classList.add('dokument-item-active');
            }
            sortDokumenteListe();
        }
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Download Links konnten nicht geladen werden!', -1);
    }
}

/**
 * Erstellt das HTML Element für eine Datei inklusive Event Listener
 * @param {*} item Dokumentobjekt
 * @param {Boolean} isPapierkorb Flag ob das Item im Papierkorb Verzeichnis ist.
 * @returns 
 */
function erstelleDokumentHTML(item, isPapierkorb) {
    const template = document.querySelector('[dokument-item-template]');
    const newItem = template.content.cloneNode(true).children[0];
    const itemName = newItem.querySelector('.dokument-name');
    itemName.innerText = item.Name;
    itemName.title = item.Name;
    const itemInfo = newItem.querySelector('.dokument-info');
    itemInfo.querySelector('[aria-label="dokument-UserUpdate"]').innerText = item.UserUpdate || item.UserErstellt;
    const datum = item.DatumUpdate || item.DatumErstellt;
    itemInfo.querySelector('[aria-label="dokument-DatumUpdate"]').innerText = dayjs(datum).tz().format('DD.MM.YY HH:mm');
    const checkbox = newItem.querySelector('.dokument-freigeben-checkbox');
    checkbox.checked = item.Freigeben;
    checkbox.addEventListener('input', async (event) => {
        await freigabeDatei(checkbox, event);
    });
    // Verhindert, dass die Datei geladen wird, wir wollen nur die freigabe Aktion durchführen
    checkbox.addEventListener('click', async (event) => event.stopPropagation());
    newItem.id = item._id;
    const docIcon = newItem.querySelector('.dokument-icon');
    // je nach Dateityp, laden wir ein Icon
    switch (item.MimeType) {
        case 'application/pdf':
            docIcon.innerHTML = '<i class="bi bi-file-pdf-fill"></i>';
            break;
        case 'image/png':
        case 'image/jpg':
        case 'image/jpeg':
            docIcon.innerHTML = '<i class="bi bi-file-image-fill"></i>';
            break;
        case 'application/vnd.oasis.opendocument.text':
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'image/tiff':
            docIcon.innerHTML = '<i class="bi bi-file-earmark-arrow-down-fill"></i>';
            break;
        default:
            docIcon.innerHTML = '<i class="bi bi-file-text-fill"></i>';
            break;
    }
    
    newItem.addEventListener('click', async () => {
        if (window.myServices.editorService.getCurrentFile) {
            await updateEntwurf();
            window.myServices.editorService.reset();
        }
        document.getElementById('postfach-filename-edit').value = item.Name;
        setMenuActive(newItem, 'dokument-item-active');

        // Remove from NeueUploads if badge exists
        const badge = newItem.querySelector('.notification-badge');
        if (badge) {
            badge.remove();
            // Update the verzeichnis badge count
            const neueUploads = stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueUploads;
            const uploadIndex = neueUploads.findIndex((docID) => _.isEqual(docID, item._id));
            if (uploadIndex !== -1) {
                neueUploads.splice(uploadIndex, 1);
            }
            // Save the updated Mitarbeiter data
            await stammdatenService.updateMitarbeiterdaten(stammdatenService.aktuellerMitarbeiter);
            // Zeige das Upload Symbol beim Mitarbeiter an falls auf unerledigt gesetzt und ausblenden wenn erledigt
            const maControl = document.getElementById(stammdatenService.aktuellerMitarbeiter._id);
            const uploadsSymbolMA = maControl.querySelector('.ma-uploads-icon');
            stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueUploads?.length <= 0 
                ? uploadsSymbolMA.classList.add('hidden')
                : uploadsSymbolMA.classList.remove('hidden');

            // Update the Uploads verzeichnis badge
            const liste = document.querySelector('#verzeichnisse-liste');
            const uploadsVerzeichnis = stammdatenService.unternehmensobjekt.Verzeichnisse.find((vz) => vz.VerzeichnisName === 'Uploads');
            const uploadsHTML = liste.querySelector(`#${CSS.escape(uploadsVerzeichnis._id)}`);
            const existingBadge = uploadsHTML.querySelector('.notification-badge');
            
            if (neueUploads.length > 0) {
                if (existingBadge) {
                    existingBadge.innerText = neueUploads.length;
                }
            } else {
                if (existingBadge) {
                    existingBadge.remove();
                }
            }
        }
        const docUrl = `/neolohn/api/dokument/${item._id}`; 
        // je nach Dateityp, müssen wir den entsprechenden viewer laden
        switch (item.MimeType) {
            case 'text/markdown':
                await ladeMarkdown(item._id);
                break;
            case 'application/pdf':
                ladePDF(docUrl + '/' + (decodeURIComponent(item.Name)));
                break;
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
                ladeImage(docUrl);
                break;
            case 'application/vnd.oasis.opendocument.text':
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'image/tiff':
                downloadLink(docUrl, item.Name);
                togglePostfachViewer();
                break;
            default:
                systemNachrichtService.zeigeKleineNachricht('ungültiges Datenformat!', -1);
                togglePostfachViewer();
                break;
        }
    });

    if (isPapierkorb) {
        newItem.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            const contextMenu = document.createElement('div');
            contextMenu.classList.add('context-delete');
            contextMenu.style.position = 'absolute';
            // Get the click position relative to the container
            let rect = event.target.closest('.ma-container').getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;
            contextMenu.style.left = `${x}px`;
            contextMenu.style.top = `${y}px`;
            contextMenu.innerText = 'endgültig löschen';
            contextMenu.addEventListener('click', async () => {
                const result = await stammdatenService.entferneDatei(item._id);
                if (result) {
                    newItem.remove();
                    // Wir updaten den aktuellen Content des Editors, damit dieser später keine alten Daten speichert.
                    window.myServices.editorService.reset();
                    [...document.body.querySelectorAll('.context-delete')].forEach((menu) => menu.remove());
                }
            });
            document.body.querySelector('.schriftverkehr-container').appendChild(contextMenu);
        });
    }
    return newItem;
}

/**
 * Zeigt die Liste an Verzeichnissen im Unternehmen an
 */
async function holeVerzeichnisliste() {
    const verzeichnisse = stammdatenService.unternehmensobjekt.Verzeichnisse.filter((vz) => vz.VerzeichnisName !== 'Papierkorb');
    const template = document.querySelector('[verzeichnis-item-template]');
    // Wir resetten die Dokument und Verzeichnislisten, um zu vermeiden, dass Daten eines anderen Mitarbeiters verbleiben.
    const docListe = document.querySelector('#dokumente-liste');
    docListe.innerHTML = '';
    // Wenn mir Mitarbeiter wechseln, bleiben wir im gleichen Verzeichnis.
    const offenesVerzeichnis = document.querySelector('.verzeichnis-item-active');
    const liste = document.querySelector('#verzeichnisse-liste');
    if (offenesVerzeichnis) {
        const offenesVerzeichnisID = offenesVerzeichnis.closest('form').id;
        // prüfe ob Nachrichten-Verzeichnis aktiv ist
        if (offenesVerzeichnisID === 'nachrichten-dir') {
            await openNachrichten();
        } else {
            await holeDocListe(offenesVerzeichnisID);
        }
        if (window.myVars.HideMod || window.myVars.HideMod2) {
            return;
        }
        // Notification Icon Reset
        verzeichnisse.forEach((item) => {
            // Add notification badge for NeueUploads in Uploads folder
            const neueUploads = stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueUploads;
            const verzeichnisHTML = liste.querySelector(`#${CSS.escape(item._id)}`);
            if (item.VerzeichnisName === 'Uploads' && neueUploads && neueUploads.length > 0) {
                const badge = createNotificationBadge(neueUploads.length, `${neueUploads.length} neue Datei(en) im Verzeichnis`);
                verzeichnisHTML.children[0].appendChild(badge);
            } else {
                const existingBadge = verzeichnisHTML.querySelector('.notification-badge');
                if (existingBadge) {
                    existingBadge.remove();
                }
            }
        });
    } else {
        liste.innerHTML = '';
        if (!window.myVars.HideMod && !window.myVars.HideMod2) {
            verzeichnisse.forEach((item) => {
                const newItem = template.content.cloneNode(true).children[0];
                newItem.querySelector('.verzeichnis-name').innerText = item.VerzeichnisName;
                const checkbox = newItem.querySelector('.verzeichnis-freigeben-checkbox');
                checkbox.checked = item.Freigeben;
                checkbox.addEventListener('click', (event) => event.stopPropagation());
                newItem.id = item._id;
    
                // Add notification badge for NeueUploads in Uploads folder
                const neueUploads = stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueUploads;
                if (item.VerzeichnisName === 'Uploads' && neueUploads && neueUploads.length > 0) {
                    const badge = createNotificationBadge(neueUploads.length, `${neueUploads.length} neue Datei(en) im Verzeichnis`);
                    newItem.querySelector('.verzeichnis-name').parentElement.appendChild(badge);
                } else {
                    const existingBadge = newItem.querySelector('.notification-badge');
                    if (existingBadge) {
                        existingBadge.remove();
                    }
                }
    
                newItem.addEventListener('click', async () => {
                    await holeDocListe(item._id);
                });
                addDragAndDropEvents(newItem.children[0]);
                liste.appendChild(newItem);
            });
            // Zusätzlich geben wir die option alle Dateien anzuzeigen
            const alleVerzeichnis = template.content.cloneNode(true).children[0];
            alleVerzeichnis.querySelector('.verzeichnis-name').innerText = 'Alle';
            alleVerzeichnis.children[0].style.borderColor = 'var(--primary-color)';
            alleVerzeichnis.querySelector('.verzeichnis-freigeben-checkbox').style.display = 'none';
            alleVerzeichnis.addEventListener('click', async () => {
                setMenuActive(alleVerzeichnis.children[0], 'verzeichnis-item-active');
                await holeDocListe('');
            });
            liste.appendChild(alleVerzeichnis);
            // Schließlich kommt noch das Papierkorb Verzeichnis
            const papierkorb = stammdatenService.unternehmensobjekt.Verzeichnisse.find((vz) => vz.VerzeichnisName === 'Papierkorb');
            const papierkorbHMTL = template.content.cloneNode(true).children[0];
            papierkorbHMTL.id = papierkorb._id;
            papierkorbHMTL.classList.add('papierkorb-verzeichnis');
            papierkorbHMTL.querySelector('.verzeichnis-name').innerText = papierkorb.VerzeichnisName;
            papierkorbHMTL.querySelector('.verzeichnis-freigeben-checkbox').style.display = 'none';
            papierkorbHMTL.addEventListener('click', async () => {
                setMenuActive(papierkorbHMTL.children[0], 'verzeichnis-item-active');
                await holeDocListe(papierkorb._id);
            });
            addDragAndDropEvents(papierkorbHMTL.children[0], false);
            liste.appendChild(papierkorbHMTL);
        }
        // Nach dem Erstellen aller Verzeichnisse appenden wir ein hartcodiertes "Nachrichten"-Verzeichnis
        const nachrichtenItem = template.content.cloneNode(true).children[0];
        nachrichtenItem.querySelector('.verzeichnis-name').innerText = 'Nachrichten (App)';
        nachrichtenItem.querySelector('.verzeichnis-freigeben-checkbox').style.display = 'none';
        nachrichtenItem.id = 'nachrichten-dir';
        nachrichtenItem.addEventListener('click', async () => {
            await openNachrichten();
            const existingBadge = nachrichtenItem.querySelector('.notification-badge');
            if (existingBadge) {
                existingBadge.remove(); 
            }
        });
        liste.insertAdjacentElement('afterbegin', nachrichtenItem);
        if (stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueMitteilung) {
            const badge = createNotificationBadge(0, 'neue Mitarbeiter Mitteilungen');
            nachrichtenItem.querySelector('.verzeichnis-name').parentElement.appendChild(badge);
        }
    }
}

function createNotificationBadge(count, title) {
    const badge = document.createElement('span');
    badge.className = 'notification-badge';
    badge.title = title;
    badge.innerText = count > 0 ? count : '';
    return badge;
}

/**
 * Resettet alle Viewer und blendet dessen Content aus der Oberfläche aus.
 */
function resetPostfachViewer() {
    togglePostfachViewer(0);
    const imageViewer = document.getElementById('image-viewer');
    window.myServices.editorService.reset();
    imageViewer.querySelector('#postfach-img').src = '';
    const pdfEmbed = document.getElementById('pdf-embed');
    if (pdfEmbed) pdfEmbed.src = '';
}

/**
 * Togglt den Conten Viewer im Mitarbeiter Postfach
 * @param {int} toggleId 1: Markdown, 2: Image, 3: PDF, 4: Nachrichten, default: alle Viewer ausblenden
 */
function togglePostfachViewer(toggleId) {
    const mdEditor = document.getElementById('markdown-viewer');
    const imageViewer = document.getElementById('image-viewer');
    const pdfViewer = document.getElementById('pdf-viewer');
    const nachrichtenViewer = document.getElementById('nachrichten-viewer');
    mdEditor.style.display = 'none';
    pdfViewer.style.display = 'none';
    imageViewer.style.display = 'none';
    nachrichtenViewer.style.display = 'none';
    switch (toggleId) {
        case 1:
            mdEditor.style.display = 'flex';
            break;
        case 2:
            imageViewer.style.display = 'block';
            break;
        case 3:
            pdfViewer.style.display = 'block';
            break;
        case 4:
            nachrichtenViewer.style.display = 'flex';
            break;
        default:
            break;
    }
}

/**
 * Lädt die aktuelle Datei per fetch und formData hoch
 * @param {HTMLElement} thisElement file input Element des Verzeichnisses
 */
async function uploadDatei(thisElement) {
    const inputForm = thisElement.closest('form');
    const verzeichnisID = inputForm.id;
    const file = new FormData(inputForm);
    const allowedDataFormats = [
        'application/pdf',
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/vnd.oasis.opendocument.text',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/tiff',
    ];
    if (!allowedDataFormats.includes(file.get('file-upload').type)) {
        systemNachrichtService.zeigeKleineNachricht('Nur .png, .jpg, .pdf, .odt, .doc, docx, .tiff Dateien sind erlaubt!');
        return;
    }
    file.append('VerzeichnisID', verzeichnisID);
    file.append('MitarbeiterID', stammdatenService.aktuellerMitarbeiter._id);
    try {
        const response = await fetch('/neolohn/api/dokument', {
            method: 'POST',
            body: file
        });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        await holeDocListe(verzeichnisID);
        systemNachrichtService.zeigeKleineNachricht('Upload erfolgerich!', 1);
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Upload fehlgeschlagen!', -1);
    }
}

/**
 * Sendet die Anfrage an des Server, die ausgewählte Datei freizugeben (oder die Freigabe zu widerrufen)
 * @param {HTMLElement} thisElement input[type=checkbox]
 */
async function freigabeDatei(thisElement, event) {
    event.stopPropagation();
    const dokumentID = thisElement.closest('.dokument-liste-item').id;
    try {
        const response = await fetch('/neolohn/api/dokument/freigeben', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ DokumentID: dokumentID })
        });
        if (response.ok) {
            systemNachrichtService.zeigeKleineNachricht('Dokumentfreigabe aktualisiert!', 1);
        }
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Aktualisierung fehlgeschlagen!', -1);
    }
}

/**
 * Verschiebt eine HTML Datei in ein anders Verzeichnis
 * @param {string} verzeichnisNeu ID des neuen Verzeichnisses
 * @param {string} dokumentID ID der Datei
 */
async function verschiebeDatei(verzeichnisNeu, dokumentID) {
    try {
        const body = {
            DokumentID: dokumentID,
            VerzeichnisID: verzeichnisNeu
        };
        const response = await fetch('/neolohn/api/dokument/verschieben', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        if (response.ok) {
            const result = await response.json();
            // Wir updaten den aktuellen Content des Editors, damit dieser später keine alten Daten speichert.
            if (window.myServices.editorService.getCurrentFile()._id === result._id) {
                window.myServices.editorService.setCurrentFile(result);
            }
            systemNachrichtService.zeigeKleineNachricht('Verschieben der Datei erfolgreich!', 1);
        }
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Fehler beim Verschieben der Datei!', -1);
    }
}


/**
 * Fügt die Drag and Drop Events dem Verzeichnis hinzu
 * - markiert das Verzeichnis, falls es per Drag überflogen wird
 * - unmarkiert es, falls es nicht mehr überflogen wird
 * - ladet die Datei hoch falls die Datei gedropped wird ins Verzeichnis
 * @param {HTMLElement} verzeichnisElement
 */
function addDragAndDropEvents(verzeichnisElement, allowUploads = true) {
    const start = ['dragover', 'dragenter'];
    const end = ['dragleave', 'dragend'];
    start.forEach((dragEvent) => {
        verzeichnisElement.addEventListener(dragEvent, (event) => {
            event.preventDefault();
            verzeichnisElement.classList.add('drop-zone-dragover');
        });
    });
    end.forEach((dragEvent) => {
        verzeichnisElement.addEventListener(dragEvent, (event) => {
            event.preventDefault();
            verzeichnisElement.classList.remove('drop-zone-dragover');
        });
    });

    verzeichnisElement.addEventListener('drop', async (e) => {
        e.preventDefault();
        verzeichnisElement.classList.remove('drop-zone-dragover');
        // Falls wir eine Datei als HTML Element verschieben, müssen wir die DokumentID und neue VerzeichnisID angeben
        if (e.dataTransfer.getData('docID') !== '') {
            const docID = e.dataTransfer.getData('docID');
            const aktuellesVerzeichnis = document.querySelector('.verzeichnis-item-active').closest('form').id;
            const neuesVerzeichnis = verzeichnisElement.closest('form').id;
            const papierkorb = document.querySelector('.papierkorb-verzeichnis').id;
            await verschiebeDatei(neuesVerzeichnis, docID);
            // Das Dokument wird nur ausgeblendet, falls wir uns nicht in Alle Verzeichnis befinden (außer beim Verschieben in den Papierkorb).
            if (((aktuellesVerzeichnis !== '') || (aktuellesVerzeichnis === '' && neuesVerzeichnis === papierkorb)) && aktuellesVerzeichnis !== neuesVerzeichnis) {
                document.getElementById(docID).remove();
            }
            return;
        }
        // Falls wir richtige Dateien hochladen...
        if (allowUploads) {
            const input = verzeichnisElement.querySelector('.input-file-upload');
            input.files = e.dataTransfer.files;
            await uploadDatei(verzeichnisElement);
        }
    });
}

function sortDokumenteName(thisElement) {
	if (thisElement.classList.contains('bi-sort-alpha-down')) {
        // sort A to Z
		thisElement.classList.add('bi-sort-alpha-up');
		thisElement.classList.remove('bi-sort-alpha-down');
        window.myVars.sortDokumentType = 0;
	} else {
        // sort Z to A
		thisElement.classList.add('bi-sort-alpha-down');
		thisElement.classList.remove('bi-sort-alpha-up');
        window.myVars.sortDokumentType = 1;
	}
	sortDokumenteListe();
}

function sortDokumenteDatum(thisElement) {
	if (thisElement.classList.contains('bi-sort-numeric-down')) {
        // sort newest to oldest
		thisElement.classList.add('bi-sort-numeric-up');
		thisElement.classList.remove('bi-sort-numeric-down');
        window.myVars.sortDokumentType = 2;
	} else {
        // sort oldest to newest
		thisElement.classList.add('bi-sort-numeric-down');
		thisElement.classList.remove('bi-sort-numeric-up');
        window.myVars.sortDokumentType = 3;
	}
	sortDokumenteListe();
}

function sortDokumenteListe() {
    const docList = document.getElementById('dokumente-liste');
    const itemlist = [...docList.children];
    itemlist.sort((a, b) => {
        if (window.myVars.sortDokumentType == 0 || window.myVars.sortDokumentType == 1) {
            const nameA = a.querySelector('[aria-label="dokument-name"]').innerText;
            const nameB = b.querySelector('[aria-label="dokument-name"]').innerText;
            return window.myVars.sortDokumentType == 0 ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        }
        if (window.myVars.sortDokumentType == 2 || window.myVars.sortDokumentType == 3) {
            const dateA = dayjs(a.querySelector('[aria-label="dokument-DatumUpdate"]').innerText, 'DD.MM.YY HH:mm');
            const dateB = dayjs(b.querySelector('[aria-label="dokument-DatumUpdate"]').innerText, 'DD.MM.YY HH:mm');
            if (window.myVars.sortDokumentType == 2) {
                return dateA.isBefore(dateB) ? 1 : -1;
            } else {
                return dateB.isBefore(dateA) ? 1 : -1;
            } 
        }
	});
    itemlist.forEach((item) => docList.appendChild(item));
}


async function openNachrichten() {
    // ensure a MA selected
    if (_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
        systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter ausgewählt!', 0);
        return;
    }
    // markiere das Verzeichnis aktiv
    document.querySelectorAll('.report-item-active, .verzeichnis-item-active').forEach(e => e.classList.remove('verzeichnis-item-active'));
    const listeElem = document.getElementById('nachrichten-dir');
    if (listeElem) listeElem.children[0].classList.add('verzeichnis-item-active');

    // zeige viewer
    togglePostfachViewer(4); // hide others
    // hide documents
    const liste = document.querySelector('#dokumente-liste');
    liste.innerHTML = '';
    await loadNachrichten();
}

async function loadNachrichten() {
    try {
        const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
        const response = await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/nachrichten`);
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg);
            throw new Error(`HTTP error, status = ${response.status}`);
        }
        const messages = await response.json();
        renderNachrichten(messages || []);
        // Nach dem Rendern markieren wir alle ungelesenen Nachrichten als gelesen
        await markiereNachrichtenGelesen(mitarbeiterID, messages || []);
    } catch (err) {
        console.error(err);
        systemNachrichtService.zeigeKleineNachricht('Nachrichten konnten nicht geladen werden!', -1);
    }
}

async function markiereNachrichtenGelesen(mitarbeiterID, nachrichten) {
    const unreadMessageIds = nachrichten
        .filter(msg => !msg.IsRead && !msg.IsOwner)
        .map(msg => msg._id);
    
    if (unreadMessageIds.length === 0 && !stammdatenService.aktuellerMitarbeiter.Uebersicht.NeueMitteilung) return;

    try {
        await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/nachrichten/mark-read`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nachrichtIDs: unreadMessageIds })
        });
        // aktualisieren der Mitarbeiter Liste, um inbox icons zu aktualisieren.
	    await erstelleMitarbeiterListe();
        
    } catch (err) {
        console.error('Fehler beim Markieren als gelesen:', err);
    }
}

function renderNachrichten(messages) {
    const list = document.getElementById('nachrichten-list');
    list.innerHTML = '';
    if (!messages.length) {
        const empty = document.createElement('div');
        empty.className = 'nachricht-empty';
        empty.innerText = 'Noch keine Nachrichten vorhanden.';
        list.appendChild(empty);
        return;
    }
    messages.forEach((m) => {
        const isOwner = !!m.IsOwner;
        const wrapper = document.createElement('div');
        wrapper.className = `nachricht-item ${isOwner ? 'nachricht-owner' : 'nachricht-employee'}`;

        const meta = document.createElement('div');
        meta.className = 'nachricht-meta';

        const badge = document.createElement('span');
        badge.className = 'nachricht-badge';
        badge.innerText = m.User || 'unbekannt';
        meta.appendChild(badge);

        const time = document.createElement('span');
        time.className = 'nachricht-time';
        time.innerText = dayjs(m.Datum).format('DD.MM.YY HH:mm');
        meta.appendChild(time);

        const content = document.createElement('div');
        content.className = 'nachricht-text';
        content.innerText = m.Nachricht;
        // Gelöschte Nachrichten kursiv
        if (m.IsDeleted) {
            content.classList.add('nachricht-deleted');
        }

        wrapper.appendChild(meta);
        wrapper.appendChild(content);

        if (m.IsOwner && !m.IsDeleted) {
            const revoke = document.createElement('span');
            revoke.className = 'nachricht-revoke';
            revoke.innerHTML = '<i class="bi bi-trash-fill"></i>';
            revoke.title = 'Nachricht löschen';
            revoke.onclick = async () => {
                await revokeNachricht(m._id);
            };
            meta.appendChild(revoke);
        }
        list.appendChild(wrapper);
    });
    // scroll to bottom
    list.scrollTop = list.scrollHeight;
}

async function sendNachricht(event) {
    // Absenden mit Enter Taste erlauben (nur bei Enter ohne Shift oder Ctrl)
    if (event) {
       if (event && event.key == 'Enter' && !event.shiftKey && !event.ctrlKey) {
            event.preventDefault();
        } else {
            // Wenn normale Taste gedrückt wird, dann senden wir keine Nachricht.
            return;
        }
    }
    const input = document.getElementById('nachricht-input');
    const text = input.value && input.value.trim();
    if (!text) return;
    try {
        const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
        const body = { MitarbeiterID: mitarbeiterID, Nachricht: text };
        const response = await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/nachrichten`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg || 'Senden fehlgeschlagen', 0);
            return;
        }
        input.value = '';
        await loadNachrichten();
        systemNachrichtService.zeigeKleineNachricht('Nachricht gesendet', 1);
    } catch (err) {
        console.error(err);
        systemNachrichtService.zeigeKleineNachricht('Senden fehlgeschlagen', -1);
    }
}

async function revokeNachricht(nachrichtID) {
    try {
        const confirmed = await SystemDialogService.instance.displayAsync('nachricht-delete-dialog');
        if (!confirmed || !confirmed.success) return;
        const mitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
        const response = await fetch(`/neolohn/api/mitarbeiter/${mitarbeiterID}/nachrichten/${nachrichtID}`, { method: 'DELETE' });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg || 'Löschen fehlgeschlagen', 0);
            return;
        }
        await loadNachrichten();
        systemNachrichtService.zeigeKleineNachricht('Nachricht gelöscht', 1);
    } catch (err) {
        console.error(err);
        systemNachrichtService.zeigeKleineNachricht('Löschen fehlgeschlagen', -1);
    }
}

export {
    ladeMitarbeiterPostfach
};
